export var BenefitStatus;
(function (BenefitStatus) {
    BenefitStatus["Available"] = "Available";
    BenefitStatus["Unavailable"] = "Unavailable";
})(BenefitStatus || (BenefitStatus = {}));
